//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ForceFailCaptcha: FeatureFlag = {"Id":"ForceFailCaptcha","Label":"(QA) FORCE ALL CAPTCHA CHECKS TO FAIL","Impact":"For testing captcha. CAPTCHA checks always fails.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":4};
